module.exports = __webpack_public_path__ + "img/hr-cliff-inner.1bd02e43.png";